var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "trade-order" },
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "header flex align-center" }, [
          _c("a", { staticClass: "pointer title mar-r5" }, [
            _c("span", [_vm._v("订单处理")])
          ]),
          !_vm.isClick
            ? _c(
                "div",
                { staticClass: "pointer flex items-center" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        placement: "bottom",
                        effect: "dark",
                        content: _vm.tooltip
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-warning-outline gray6 f18 mar5-l"
                      })
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "items h140"
        },
        [
          _c(
            "a",
            {
              staticClass: "gray6 item",
              on: {
                click: function($event) {
                  return _vm.$openHome(
                    _vm.origin.VUE_APP_APP +
                      "mj/order/manage/orderList.do?appid=1&tag=1",
                    "待客户支付-我的订单",
                    0,
                    _vm.isClick
                  )
                }
              }
            },
            [
              _vm.salesAuthority && _vm.shopId
                ? _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.orderInfo.orderStatus1 || 0))
                  ])
                : _c("span", { staticClass: "num" }, [_vm._v("****")]),
              _c("span", [_vm._v("待客户支付")])
            ]
          ),
          _c(
            "a",
            {
              staticClass: "gray6 item",
              on: {
                click: function($event) {
                  return _vm.$openHome(
                    _vm.origin.VUE_APP_APP +
                      "mj/order/manage/orderList.do?appid=1&tag=2",
                    "待我发货-我的订单",
                    0,
                    _vm.isClick
                  )
                }
              }
            },
            [
              _vm.salesAuthority && _vm.shopId
                ? _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.orderInfo.orderStatus2 || 0))
                  ])
                : _c("span", { staticClass: "num" }, [_vm._v("****")]),
              _c("span", [_vm._v("待我发货")])
            ]
          ),
          _c(
            "a",
            {
              staticClass: "gray6 item",
              on: {
                click: function($event) {
                  return _vm.$openHome(
                    _vm.origin.VUE_APP_APP +
                      "mj/order/manage/orderList.do?appid=1&tag=3",
                    "待客户确认-我的订单",
                    0,
                    _vm.isClick
                  )
                }
              }
            },
            [
              _vm.salesAuthority && _vm.shopId
                ? _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.orderInfo.orderStatus3 || 0))
                  ])
                : _c("span", { staticClass: "num" }, [_vm._v("****")]),
              _c("span", [_vm._v("待客户确认")])
            ]
          ),
          _c(
            "a",
            {
              staticClass: "gray6 item",
              on: {
                click: function($event) {
                  return _vm.$openHome(
                    _vm.origin.VUE_APP_APP +
                      "mj/toIsPublicDisplayPriceMJ.do?appid=1",
                    "购买咨询",
                    0,
                    _vm.isClick
                  )
                }
              }
            },
            [
              _vm.salesAuthority && _vm.shopId
                ? _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.orderInfo.buyPurpose || 0))
                  ])
                : _c("span", { staticClass: "num" }, [_vm._v("****")]),
              _c("span", [_vm._v("购买咨询")])
            ]
          ),
          _c(
            "a",
            {
              staticClass: "gray6 item",
              on: {
                click: function($event) {
                  return _vm.$openHome(
                    _vm.origin.VUE_APP_APP + "v/aftersales/sellerList?appid=1",
                    "售后订单-我的订单",
                    0,
                    _vm.isClick
                  )
                }
              }
            },
            [
              _vm.salesAuthority && _vm.shopId
                ? _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.orderInfo.refundStatusCount || 0))
                  ])
                : _c("span", { staticClass: "num" }, [_vm._v("****")]),
              _c("span", [_vm._v("售后订单")])
            ]
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }